import { render, staticRenderFns } from "./CoFormInput.vue?vue&type=template&id=0f0e6c17&scoped=true&"
import script from "./CoFormInput.vue?vue&type=script&lang=js&"
export * from "./CoFormInput.vue?vue&type=script&lang=js&"
import style0 from "./CoFormInput.vue?vue&type=style&index=0&id=0f0e6c17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e6c17",
  null
  
)

export default component.exports